module.exports = __webpack_public_path__ + "2b02b53aea62cc0c604b5b095fa62d49.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/bok_amor_towles.png
// module id = 169
// module chunks = 0